import React from 'react'

import { Outline } from '@cinch/oxd-components/button/src'
import Table from '@cinch/oxd-components/table/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import { DamageItem } from '../../../types'

interface TableProps {
  damages: DamageItem[]

  onRemoveDamage: (index: number) => void
}

/**
 * Super simple component that displays a table of damages and has a button to remove a row
 */
const DamageTableComponent: React.FC<TableProps> = ({ damages, onRemoveDamage }) => {
  return (
    <>
      <Text oxford={true} type={TextStyles.cardTitle}>
        Damage items
      </Text>
      <Table>
        <thead>
          <tr>
            <th>Zone</th>
            <th>Component</th>
            <th>Fault</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {damages.map((damage, index) => (
            <tr key={index}>
              <td>{damage.vehicleZoneName}</td>
              <td>{damage.componentName}</td>
              <td>{damage.faultName}</td>
              <td style={{ textAlign: 'right' }}>
                <Outline type="button" size={'mini'} onClick={() => onRemoveDamage(index)}>
                  Remove
                </Outline>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default DamageTableComponent
